import { RouteObject } from 'react-router-dom'
import { Gate } from '@/components/shared/gate/Gate'
import { ListKehadiran } from '@/pages/dashboard/kehadiran/ListKehadiran'
import { ListCuti } from '@/pages/dashboard/cuti/ListCuti'
import { ListPengajuanReimburse } from '@/pages/dashboard/pengajuanReimburse/ListPengajuanReimburse'
import { ListPengajuanLembur } from '@/pages/dashboard/pengajuanLembur/ListPengajuanLembur'
import { ListPengajuanPerjalananDinas } from '@/pages/dashboard/pengajuanPerjalananDinas/ListPengajuanPerjalananDinas'
import { ListKPIHarian } from '@/pages/dashboard/pemantauanKPI/ListKPIHarian'
import { ListPengajuanLoan } from '@/pages/dashboard/pengajuanLoan/ListPengajuanLoan'
import { ListPengajuanBeasiswa } from '@/pages/dashboard/beasiswa/ListPengajuanBeasiswa'
import { KpiLeadership } from '@/pages/dashboard/kpi/KpiLeadership'
import { KpiGRD } from '@/pages/dashboard/kpiGRD/KpiGRD'
import { Roles } from '@/utils/constants/roles'
import { env } from '@/utils/constants/env'
import { KpiBulanan } from '@/pages/dashboard/kpi/bulanan/KpiBulanan'

const availableMetabase = (env.showMetabase || 'all').split(',')

const dashboardRoutes: RouteObject[] = [
  {
    path: '/dashboard/kehadiran-makan-siang',
    element: <Gate />,
    children: [{ index: true, element: <ListKehadiran /> }],
    id: 'prosesKehadiranMakanSiang',
  },
  {
    path: '/dashboard/pengajuan-cuti',
    element: <Gate />,
    children: [{ index: true, element: <ListCuti /> }],
    id: 'proses_pengajuan_cuti_ciomy',
  },
  {
    path: '/dashboard/pengajuan-reimburse',
    element: <Gate />,
    children: [{ index: true, element: <ListPengajuanReimburse /> }],
    id: 'pengajuanReimburse',
  },
  {
    path: '/dashboard/pengajuan-lembur',
    element: <Gate />,
    children: [{ index: true, element: <ListPengajuanLembur /> }],
    id: 'pengajuanLembur',
  },
  {
    path: '/dashboard/pengajuan-perjalanan-dinas',
    element: <Gate />,
    children: [{ index: true, element: <ListPengajuanPerjalananDinas /> }],
    id: 'pengajuanPerjalananDinas',
  },
  {
    path: '/dashboard/pemantauan-kpi-harian',
    element: <Gate />,
    children: [{ index: true, element: <ListKPIHarian /> }],
    id: 'pemantauanKPIHarian',
  },
  {
    path: '/dashboard/pengajuan-soft-loan',
    element: <Gate />,
    children: [{ index: true, element: <ListPengajuanLoan /> }],
    id: 'pengajuanLoan',
  },
  {
    path: '/dashboard/pengajuan-beasiswa',
    element: <Gate />,
    children: [{ index: true, element: <ListPengajuanBeasiswa /> }],
    id: 'pengajuanBeasiswa',
  },
  {
    path: '/dashboard/kpi-leadership',
    element: <Gate />,
    children: [{ index: true, element: <KpiLeadership /> }],
    id: 'StartKPILeadership',
  },
  {
    path: '/dashboard/pemantauan-kpi-grd',
    element: (
      <Gate
        role={[
          Roles.Director,
          Roles.ManagerHR,
          Roles.ManagerMarketingBranding,
          Roles.ManagerProduksi,
          Roles.ManagerSalesOffline,
          Roles.ManagerSalesOnline,
          Roles.ManagerWarehouse,
          Roles.StaffHR,
        ]}
      />
    ),
    children: [{ index: true, element: <KpiGRD /> }],
    id: 'Pengajuan-pemantauan-KPI-GRD',
  },
  {
    path: '/dashboard/kpi-bulanan',
    element: <Gate />,
    children: [{ index: true, element: <KpiBulanan /> }],
    id: 'kpiBulanan',
  },
].filter((route) => availableMetabase.includes(route.id) || availableMetabase.includes('all'))

export default dashboardRoutes
